import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrowserWorkflowApiConfiguration {
  rootUrl!: string;
}

export interface IBrowserWorkflowApiConfigurationParams {
  rootUrl: string;
}
